import React, { useState } from 'react';
import {
    TextField,
    Button,
    Checkbox,
    FormControlLabel
} from '@mui/material';
import HeresAmericaService from '../../services/HA/HeresAmericaService.js';
import { displaySuccessToast, displayErrorToast } from '../../utils/toast'; // Assuming you have such utils

const AddSeries = ({ refreshSeries }) => {
    const [title, setTitle] = useState('');
    const [imageUrl, setImageUrl] = useState('');
    const [description, setDescription] = useState('');
    const [active, setActive] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const seriesData = {
                title,
                imageUrl,
                description,
                active
            };
            console.log("🚀 ~ file: AddSeries.jsx:29 ~ handleSubmit ~ seriesData:", seriesData)

            // Assuming you have a method createSeries in HeresAmericaService
            const newSeries = await HeresAmericaService.createSeries(seriesData);
            console.log(newSeries)
            refreshSeries()
            displaySuccessToast("Series added successfully");
            setIsLoading(false);
        } catch (error) {
            displayErrorToast(`Error adding series: ${error.response.data.error}`);
            setIsLoading(false);
            console.error('An error occurred while adding the series:', error);
        }
    };


    return (
        <div>
            <h2>Add New Series</h2>
            <form onSubmit={handleSubmit}>
                <TextField
                    label="Title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    fullWidth
                    variant="standard"

                    required

                />
                <TextField
                    label="Image URL"
                    value={imageUrl}
                    onChange={(e) => setImageUrl(e.target.value)}
                    fullWidth
                    variant="standard"


                />
                <TextField
                    label="Description"
                    value={description}
                    variant="standard"

                    onChange={(e) => setDescription(e.target.value)}
                    fullWidth

                />
                <FormControlLabel
                    control={<Checkbox checked={active} onChange={(e) => setActive(e.target.checked)} />}
                    label="Active"
                />
                <Button type="submit" color="primary" variant="contained" disabled={isLoading}>
                    {isLoading ? "Adding..." : "Add Series"}
                </Button>
            </form>
        </div>
    );
};

export default AddSeries;
